<div class="bbrowser-container">
  <div class="tools" *ngIf="!loadingBB && !lastError">
    <div class="tools-group" *ngIf="showSlider">
      <div>Change opacity</div>
      <input type="range" min="-1" max="101" [(ngModel)]="opacity"
        (change)="changeOpacity(opacity)" />
    </div>
    <div class="tools-group autorotate">
      <span>Autorotate</span>
      <div class="flex-row">
        <div class="btn-group">
          <fw-button size="small" [color]="xRotActive ? 'primary' : 'slate'"
            [variant]="xRotActive ? 'solid' : 'outline'"
            (click)="setRotation('x')">x</fw-button>
          <fw-button size="small" [color]="yRotActive ? 'primary' : 'slate'"
            [variant]="yRotActive ? 'solid' : 'outline'"
            (click)="setRotation('y')">y</fw-button>
          <fw-button size="small" [color]="zRotActive ? 'primary' : 'slate'"
            [variant]="zRotActive ? 'solid' : 'outline'"
            (click)="setRotation('z')">z</fw-button>
        </div>
        <fw-button size="small" color="primary" variant="outline" (click)="resetView()">Reset view</fw-button>
      </div>
    </div>
    <div class="tools-group background">
      Background Color: <input type="color" [(ngModel)]="bbrowserColor" (change)="setBackgroundcolor(bbrowserColor)">
    </div>
    <hr />
    <div class="tools-group" *ngIf="!isMni">
      <div>Select a point</div>
      <div>(Shift+click on the surface)</div>
      <br />
      <div>X: {{selectedPoint.x}}</div>
      <div>Y: {{selectedPoint.y}}</div>
      <div>Z: {{selectedPoint.z}}</div>
      <div>Vertex number: {{selectedPoint.vertex}}</div>
      <div *ngIf="selectedPoint.value">Value: {{selectedPoint.value}}</div>
    </div>
    <!-- FIXME: Currently never shown -->
    <div class="tools-group" *ngIf="isMni">
      <fw-button size="small" color="primary" variant="outline"
        [disabled]="hasMniTemplate" (click)="addMniTemplate()">Add mni template</fw-button>
    </div>
  </div>
  <div id="bbrowser-viewer" *ngIf="!lastError"></div>
</div>

<div *ngIf="loadingBB && !lastError" class="spinner-container">
  <fw-progress-spinner mode="indeterminate" size="medium" [showValue]="false"></fw-progress-spinner>
</div>

<div *ngIf="lastError" class="error-message">
  <fw-icon size="large" color="primary">warning</fw-icon>
  <div class="vision-h1">Error loading BrainBrowser</div>
</div>

<router-outlet />
